import {
  boolean,
  object,
  string,
  null as zNull,
  type infer as zInfer,
} from "zod";

export const setTeamworkCommerceIntegration = {
  name: "setTeamworkCommerceIntegration" as const,
  input: object({
    baseUrl: string(),
    apiKey: string(),
    importReceiptSettings: object({
      enabled: boolean().optional(),
      excludeOriginalReceiptNumForGreenReturns: boolean().optional(),
      fillFromLocationId: string().optional(),
      globalCharges: object({
        exchangeAdjustmentChargeId: string().optional(),
        exchangeAdjustmentMemo: string().optional(),
        shippingChargeId: string().optional(),
      }).optional(),
      importReceiptLocationId: string().optional(),
      items: object({ greenReturnItemSku: string().optional() }).optional(),
    }).optional(),
  }),
  output: zNull(),
};

export type SetTeamworkCommerceIntegrationInput = zInfer<
  typeof setTeamworkCommerceIntegration.input
>;
